import React, { useEffect } from "react";
import useApiRequest from "../../../../Hooks/apiReq";
import Iconroad from "../../../../assets/img/icon-road1.gif";
import UcrkIcon2 from "../../../../assets/img/ucrk-icon2.png";
const Rank = () => {
  const { error, loading, response, sendApiRequest } = useApiRequest();
  const dispatch = useDispatch();
  useEffect(() => {
    const user = sessionStorage.getItem("loggedInUser");
    if (!user) return;
    sendApiRequest(
      "POST",
      "/Dashboard/GetBussinessCommisionRankDetails",
      {
        action: "Rank",
      },
      {
        onSuccess: (res) => {
          dispatch(setRankDetails(res?.data));
        },
      },
    );
  }, []);
  const chartData = [
    {
      name: "Self Business",
      amount: Number(response?.selfBusinessAmount || 0),
    },
    {
      name: "Team Total",
      amount: Number(response?.teamTotalBusiness || 0),
    },
    {
      name: "Team Valid",
      amount: Number(response?.teamValidBusiness || 0),
    },
    {
      name: "Required",
      amount: Number(response?.requiredAmount || 0),
    },
    {
      name: "Target",
      amount: Number(response?.targetAmount || 0),
    },
  ];
  const targetAmount = parseFloat(response?.targetAmount || 0);
  const currentRankTargetAmount = parseFloat(
    response?.currentRankTargetAmount || 0,
  );
  const selfBusinessAmount = parseFloat(response?.selfBusinessAmount || 0);
  const teamValidBusiness = parseFloat(response?.teamValidBusiness || 0);

  const _target = targetAmount - currentRankTargetAmount;

  const _achiv =
    selfBusinessAmount + teamValidBusiness - currentRankTargetAmount;

  const _perc = Math.round((_achiv * 100) / _target);

  return (
    <div className="col-12 col-xl-6">
      <div className="card border">
        <div className="card-body p-2">
          <div className="row">
            <div class="col-lg-3">
              <h4 className="mt-2 fs-8">
                <span className="fas fa-chart-line"></span>{" "}
                <FaChartLine size={22} /> Rank Details
              </h4>
            </div>
          </div>
        </div>
        <div className="ucrk_detail-main">
          <div className="ucrk-qualifier">
            <div class="ucb-left ">
              <div className="d-inline-block w-100">
                <b className="text-black">{response?.currentRank}</b>
              </div>
              <span style={{ fontSize: "14.5px" }} className="text-dark ">
                Current Rank
              </span>
            </div>
            <div class="ucb-right">
              {/* <div>
                <b className="text-black">{response?.nextRank}</b>
              </div> */}
              <div className="rankanimation">
                <b className="text-black next-rank-text">
                  {response?.nextRank}
                </b>
              </div>
              <sapn
                style={{ fontSize: "14.5px" }}
                className=" d-inline-block w-100 "
              >
                Next Rank
              </sapn>
            </div>
            <div class="progress-1">
              <div class="boy-icon">
                <img
                  style={{ marginLeft: _perc + "%" }}
                  src={Iconroad}
                  alt=""
                />
              </div>
              <div class="progress">
                <div
                  class={response?.maxLegPerc ? "bar" : ""}
                  style={{ width: _perc + "%" }}
                >
                  <p class="percent">{Number(_perc || 0)}%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="ucrk-list">
            <b>Self Business</b>
            <span className="textColor">
              {convertToINRFormat(response?.selfBusinessAmount)}
            </span>
          </div>
          <div class="ucrk-team">
            <b className="textColor">
              Team Business Total{" "}
              <span className="textColor">
                {convertToINRFormat(response?.teamTotalBusiness)}
              </span>
            </b>
            <strong className="textColor">
              Valid{" "}
              <span className="textColor">
                {convertToINRFormat(response?.teamValidBusiness)}
              </span>
            </strong>
            <p>
              Maximum amount can consider from single team is:
              <span>
                {convertToINRFormat(response?.maxLegAmount)} (
                {Number(response?.maxLegPerc)} %)
              </span>
            </p>
          </div>
          <div class="ucrk-list">
            <b>Qualification For New Rank</b>
            <span class="green" style={{ color: "#c18824" }}>
              {convertToINRFormat(response?.targetAmount)}
            </span>
          </div>
          <div class="ucrk-using headingColor">
            Required More Business To Upgrade
          </div>
          <div class="ucrk-list">
            <b>Using Self Business</b>
            <span className="text-success">
              {convertToINRFormat(response?.requiredAmount)}
            </span>
          </div>
          <div class="ucrk-or">
            <img src={UcrkIcon2} alt="" />
          </div>
          <div class="ucrk-list">
            <b>Valid Team Business</b>
            <span className="text-success">
              {convertToINRFormat(response?.requiredAmount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(Rank);
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setRankDetails } from "../../../../Redux/Slices/profileSlice";
import {
  Area,
  CartesianGrid,
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { FaChartLine } from "react-icons/fa";

const RankCircle = ({ percentage = 0, currentRank, nextRank }) => {
  const radius = 60;
  const stroke = 10;
  const normalizedRadius = radius - stroke;
  const circumference = normalizedRadius * 2 * Math.PI;

  const [animatedPercent, setAnimatedPercent] = useState(0);
  const [offset, setOffset] = useState(circumference);

  // Animate % from 0 to final
  useEffect(() => {
    let start = 0;
    const duration = 800;
    const stepTime = 10;
    const increment = percentage / (duration / stepTime);

    const anim = setInterval(() => {
      start += increment;
      if (start >= percentage) {
        start = percentage;
        clearInterval(anim);
      }
      setAnimatedPercent(Math.round(start));
    }, stepTime);

    return () => clearInterval(anim);
  }, [percentage]);

  // Continuous animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => prev - 2);
    }, 20);

    return () => clearInterval(interval);
  }, []);

  const progressOffset =
    circumference - (animatedPercent / 100) * circumference;

  return (
    <div className="d-flex justify-content-center">
      <div
        style={{
          width: 150,
          height: 90,
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <svg width="150" height="150">
          {/* Background Circle */}
          <circle
            stroke="#e6e6e6"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="75"
            cy="75"
          />

          {/* Glowing Background Circle */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="75"
            cy="75"
            opacity="0.4"
            style={{
              filter: "blur(8px)",
            }}
            transform="rotate(-90 75 75)"
          />

          {/* Continuous rotating animation */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{
              transition: "stroke-dashoffset 0.2s linear",
              opacity: 0.3,
            }}
            r={normalizedRadius}
            cx="75"
            cy="75"
            transform="rotate(-90 75 75)"
          />

          {/* Actual % Progress */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={progressOffset}
            style={{
              transition: "stroke-dashoffset 0.4s ease",
            }}
            r={normalizedRadius}
            cx="75"
            cy="75"
            transform="rotate(-90 75 75)"
          />

          <defs>
            <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#5c27fe" />
              <stop offset="100%" stopColor="#a970ff" />
            </linearGradient>
          </defs>
        </svg>

        {/* Text in Center */}
        <div style={{ position: "absolute", textAlign: "center" }}>
          <strong
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: "#a970ff",
            }}
          >
            {animatedPercent}%
          </strong>

          <p style={{ fontSize: 10, margin: 0, color: "#777" }}>
            Rank Progress
          </p>

          <p style={{ margin: 0, fontSize: 11 }}>
            <b>{currentRank}</b> → <b>{nextRank}</b>
          </p>
        </div>
      </div>
    </div>
  );
};
